import classNames from 'classnames'

import style from './PageWrapper.module.scss'

interface IProps {
    children: React.ReactNode
    className?: string
}

export const PageWrapper = (props: IProps) => {
    const { children, className } = props
    const cn = classNames(style.container, className)
    return (
        <div className={cn}>
            <div className={style.wrapper}>{children}</div>
        </div>
    )
}
